var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUsChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#5F9E87"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4629 15.5314C21.4065 15.5314 21.3479 15.5076 21.311 15.4598L19.537 13.278L17.3573 15.0521C17.2727 15.1215 17.1491 15.1085 17.0797 15.0239C17.0103 14.9393 17.0233 14.8157 17.1079 14.7463L19.4416 12.8464C19.5261 12.777 19.6498 12.79 19.7192 12.8746L21.619 15.2083C21.6884 15.2928 21.6754 15.4165 21.5908 15.4859C21.5539 15.5162 21.5106 15.5292 21.4672 15.5292L21.4629 15.5314Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.210401
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43368 13.2119C6.37729 13.2119 6.31869 13.188 6.28182 13.1403L4.38195 10.8067C4.31255 10.7221 4.32559 10.5985 4.41017 10.5291C4.49475 10.4597 4.61838 10.4727 4.68778 10.5572L6.46185 12.7391L8.6415 10.965C8.72609 10.8956 8.84971 10.9086 8.91912 10.9932C8.98852 11.0778 8.97548 11.2014 8.89089 11.2708L6.55726 13.1707C6.52039 13.201 6.47705 13.214 6.43368 13.214V13.2119Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.210401
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9984 19.7591C10.5932 19.7591 8.34853 18.4643 7.14267 16.3801C7.08845 16.2868 7.12095 16.1654 7.21421 16.1111C7.30747 16.0569 7.42892 16.0894 7.48314 16.1827C8.61959 18.1455 10.732 19.3665 12.9984 19.3665C16.5097 19.3665 19.3638 16.5102 19.3638 13.0011C19.3638 12.8926 19.4528 12.8037 19.5612 12.8037C19.6697 12.8037 19.7586 12.8926 19.7586 13.0011C19.7586 16.7292 16.7266 19.7612 12.9984 19.7612V19.7591Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.210401
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43348 13.1968C6.32504 13.1968 6.23608 13.1079 6.23608 12.9994C6.23608 9.27125 9.2681 6.23926 12.9963 6.23926C15.4622 6.23926 17.7351 7.58392 18.9236 9.74622C18.9756 9.84165 18.9409 9.96093 18.8455 10.013C18.7501 10.065 18.6308 10.0303 18.5788 9.9349C17.4575 7.89623 15.3191 6.63181 12.9963 6.63181C9.48498 6.63181 6.63082 9.48813 6.63082 12.9972C6.63082 13.1057 6.54192 13.1946 6.43348 13.1946V13.1968Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.210401
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsChange);
export default __webpack_public_path__ + "static/media/icon-us-change.7c8d2e1c5c4dd29ef476ab09b722d201.svg";
export { ForwardRef as ReactComponent };